import { render, staticRenderFns } from "./GoodsCodeCollection.vue?vue&type=template&id=5fed9e6d&scoped=true"
import script from "./GoodsCodeCollection.vue?vue&type=script&lang=js"
export * from "./GoodsCodeCollection.vue?vue&type=script&lang=js"
import style0 from "./GoodsCodeCollection.vue?vue&type=style&index=0&id=5fed9e6d&prod&scoped=true&lang=css"
import style1 from "./GoodsCodeCollection.vue?vue&type=style&index=1&id=5fed9e6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed9e6d",
  null
  
)

export default component.exports